import { Component } from '@angular/core';
import { ConfirmationService, PrimeTemplate } from 'primeng/api';
import { MessageService } from '../../../services/message.service';
import { Dialog } from '../../../models/dialog.model';
import { DialogEnum, OptionEnum } from '../../../enumerators/messages.enum';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { NgFor, NgIf } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';

export interface SelectableOption {
  id: number;
  name: string;
  keyCode?: string;
  color?: string; // Color personalizado opcional (clase CSS)
  [key: string]: any; // Para permitir propiedades adicionales
}

@Component({
  selector: 'app-option-selector-dialog',
  templateUrl: './option-selector-dialog.component.html',
  styleUrls: ['./option-selector-dialog.component.scss'],
  standalone: true,
  imports: [ConfirmDialogModule, PrimeTemplate, NgFor, NgIf, TranslateModule],
  providers: [ConfirmationService]
})
export class OptionSelectorDialogComponent {
  dialog: Dialog = new Dialog();
  public animation: string = "";
  public isOpen: boolean = false;
  public OptionEnum = OptionEnum;
  public options: SelectableOption[] = [];
  public selectedOptionId: number | null = null;
  public showCancelButton: boolean = true;
  public defaultColor: string = 'boton--primario'; // Color por defecto

  constructor(private dialogService: MessageService, private confirmationService: ConfirmationService) {
  }

  ngOnInit() {
    this.dialogService.startOptionSelectorDialog().subscribe((data: { dialog: Dialog, options: SelectableOption[], showCancelButton?: boolean, defaultColor?: string }) => {
      this.dialog = data.dialog;
      this.options = data.options;
      this.showCancelButton = data.showCancelButton !== undefined ? data.showCancelButton : true;
      this.defaultColor = data.defaultColor || 'boton--primario';
      this.openDialog();
    });
  }

  openDialog() {
    this.setDialogData(this.dialog);

    this.confirmationService.confirm({
      message: this.dialog.message,
      header: this.dialog.title,
      icon: '', // Sin icono
      accept: () => {
        // No se usa accept en este caso
      },
      reject: () => {
        if (this.showCancelButton) {
          this.closeDialog(null);
        } else {
          // No permitir cerrar el diálogo sin seleccionar una opción
          // Volver a abrir el diálogo
          setTimeout(() => this.openDialog(), 100);
        }
      },
      key: 'optionSelector'
    });
  }

  closeDialog(optionId: number | null) {
    this.selectedOptionId = optionId;
    this.dialogService.sendOptionSelectorResponse(optionId);
    this.isOpen = false;
    this.dialog = new Dialog();
    this.options = [];
    this.selectedOptionId = null;
  }

  onOptionSelect(optionId: number) {
    this.confirmationService.close();
    this.closeDialog(optionId);
  }

  onCancel() {
    if (this.showCancelButton) {
      this.confirmationService.close();
      this.closeDialog(null);
    } else {
      // No permitir cancelar - el usuario debe seleccionar una opción
      // Volver a abrir el diálogo
      setTimeout(() => this.openDialog(), 100);
    }
  }

  // Método para obtener la clase de color de una opción
  getOptionColorClass(option: SelectableOption): string {
    return option.color || this.defaultColor;
  }

  setDialogData(dialog: Dialog) {
    // Sin iconos - método simplificado
  }
}
